import { pageInfo,marketAdd, marketDetails, marketEdit,} from './../api';
const market = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    marketAddObj:null,
    marketDetailsObj: null,
    marketEditObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    MARKET_ADD(state, data){
      state.marketAddObj = data;
    },
    MARKET_DETAILS(state, data){
      state.marketDetailsObj = data.obj;
    },
    MARKET_EDIT(state, data){
      state.marketEditObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async marketAdd({commit}, obj) {
      let result = await marketAdd(obj);
      commit('MARKET_ADD', result);
    },
    async marketDetails({commit}, obj) {
      let result = await marketDetails(obj);
      commit('MARKET_DETAILS', result);
    },
    async marketEdit({commit}, obj) {
      let result = await marketEdit(obj);
      commit('MARKET_EDIT', result);
    },
  }
}
export default market



// WEBPACK FOOTER //
// ./src/page/md/market/store/market.store.js